import { Injectable } from '@angular/core';

/**
 * Global flag for "current screen has unsaved edits".
 * Layouts use this before Back, Logout, or sidebar navigation.
 */
@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesService {
  private dirty = false;

  isDirty(): boolean {
    return this.dirty;
  }

  setDirty(value: boolean): void {
    this.dirty = value;
  }

  /** Returns true if user chose to discard or there was nothing to save. */
  confirmDiscard(message?: string): boolean {
    const msg =
      message ||
      'You have unsaved changes. If you leave now, those changes may be lost.\n\nLeave anyway?';
    return window.confirm(msg);
  }

  /** Run action only if not dirty or user confirms discard. Clears dirty after confirm. */
  runIfSafe(action: () => void): void {
    if (!this.dirty) {
      action();
      return;
    }
    if (this.confirmDiscard()) {
      this.dirty = false;
      action();
    }
  }
}
